'use client';

import { c as _c } from "react/compiler-runtime";
import * as Select from '@radix-ui/react-select';
import Image from 'next/image';
import styles from './ConsultationModal.module.scss';
type CounselingTime = 'AM' | 'PM' | 'ALL';
const OPTIONS: ReadonlyArray<{
  readonly value: CounselingTime;
  readonly label: string;
}> = [{
  value: 'AM',
  label: '오전'
}, {
  value: 'PM',
  label: '오후'
}, {
  value: 'ALL',
  label: '무관'
}];
interface CounselingTimeSelectProps {
  readonly value: CounselingTime;
  readonly onChange: (value: string) => void;
}
export default function CounselingTimeSelect(t0) {
  const $ = _c(13);
  const {
    value,
    onChange
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = OPTIONS.find(opt => opt.value === value);
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectedOption = t1;
  const t2 = selectedOption ? styles.selectValue : styles.selectPlaceholder;
  const t3 = selectedOption ? selectedOption.label : "\uC2DC\uAC04\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694";
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <Select.Value><span className={t2}>{t3}</span></Select.Value>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Select.Icon asChild={true}><span className={styles.selectArrow}><Image src="/cc/image/icon_down_arrow_gray.svg" alt="" aria-hidden={true} width={20} height={20} /></span></Select.Icon>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <Select.Trigger id="counselingTime" className={styles.selectTrigger}>{t4}{t5}</Select.Trigger>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Select.Portal><Select.Content className={styles.selectDropdown} position="popper" sideOffset={4}><Select.Viewport>{OPTIONS.map(_temp)}</Select.Viewport></Select.Content></Select.Portal>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== onChange || $[10] !== t6 || $[11] !== value) {
    t8 = <Select.Root value={value} onValueChange={onChange}>{t6}{t7}</Select.Root>;
    $[9] = onChange;
    $[10] = t6;
    $[11] = value;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}
function _temp(option) {
  return <Select.Item key={option.value} value={option.value} className={styles.selectOption}><Select.ItemText><span className={styles.selectOptionLabel}>{option.label}</span></Select.ItemText></Select.Item>;
}